<template>
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-1">
        <mdn-text class="text-xs font-bold">{{name}}</mdn-text>
        <mdn-text class="text-xs text-gray-700">{{description}}</mdn-text>
      </div>
    </div>
</template>

<script>
import { MdnText } from 'mondrian-vue'
export default {
  name: 'AppDescription',
  components: { MdnText },
  props: {
    name: String,
    description: String
  }
}
</script>
